import { FiUploadCloud } from "react-icons/fi";

const ImageUploader = ({ imagePreview, setImagePreview, setImageFile }) => {
  const handleImageChange = (event) => {
    const file = event.target.files?.[0];

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
    setImageFile(file);
  };

  return (
    <div className="bg-[#F4F7FE] dark:bg-navy-900 p-6 rounded-2xl text-center space-y-3">
      {imagePreview ? (
        <img
          src={imagePreview}
          alt="Preview"
          className="mx-auto max-h-60 rounded-lg object-contain"
        />
      ) : (
        <>
          <div className="text-4xl text-[#A3AED0] flex justify-center">
            <FiUploadCloud />
          </div>
          <h2 className="font-semibold text-sm text-[#1B2559] dark:text-white">
            Image Requirements
          </h2>
          <p className="text-[#A3AED0] text-sm">
            Image ratio looks best 5600 x 5600 max size GIF, JPG OR PNG format
            <br />
            50MB max file size
          </p>
        </>
      )}

      <div className="text-[#A3AED0] text-sm">
        Drag & Drop or{" "}
        <label
          htmlFor="imageUpload"
          className="text-[#4318FF] underline cursor-pointer"
        >
          Browse
        </label>
        <input
          id="imageUpload"
          type="file"
          accept="image/png, image/jpeg, image/gif"
          onChange={handleImageChange}
          className="hidden"
        />
      </div>
    </div>
  );
};

export default ImageUploader;
